import styled from 'styled-components'

export const LoadingWrapper = styled.div`
  height: 8.5rem;
  width: 100%;
`
